import { render, staticRenderFns } from "./ModulesList.vue?vue&type=template&id=54663bcc&scoped=true&"
import script from "./ModulesList.vue?vue&type=script&lang=ts&"
export * from "./ModulesList.vue?vue&type=script&lang=ts&"
import style0 from "./ModulesList.vue?vue&type=style&index=0&id=54663bcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54663bcc",
  null
  
)

export default component.exports